// New version src/Common/user/user_data.service.ts CommonUserDataService
// Old version src/CaseDotStar.ServicePackages.Frontend.Common/scripts/common/services/user_data_service_factory.js UserDataService

import { Injectable } from '@angular/core';
import {
	HttpClient,
	HttpHeaders,
} from '@angular/common/http';
import {
	forkJoin,
	Observable,
	of,
	Subject,
} from 'rxjs';
import {
	map,
	mergeMap,
} from 'rxjs/operators';
import {
	get,
	isArray,
	isNull,
} from 'lodash';

import {
	ICommonAuthor,
	UUID,
} from '../@types/core';
import { CommonDataServiceClass } from './data.service';
import { CommonBootstrapDataService } from './bootstrap/bootstrap_data.service';
import { commonConstants } from '../constants/common.constants';

import { CommonAppDataService } from './app_data/app_data.service';

export interface ICommonUserDataServiceData extends ICommonAuthor {
	Email: string | null;
	FileAvatarId?: UUID;
	Role?: string;
}

@Injectable({
	providedIn: 'root',
})
export class CommonUserDataService extends CommonDataServiceClass<any> {
	onAccountUpdated$: Subject<never> = new Subject();
	private res: Observable<any>;

	constructor (
		private http: HttpClient,
		private commonBootstrapDataService: CommonBootstrapDataService,
		private commonAppDataService: CommonAppDataService,
	) {
		super();
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	init (shouldLoadData = false, bootstrapPromise?: Observable<any>): Observable<any> {
		const requestOptions = {
			withCredentials: true,
			headers: new HttpHeaders({
				'Content-Type': 'application/json;charset=UTF-8',
			}),
		};

		if (window.UserData || !shouldLoadData) {
			this.res = of(window.UserData || {});
		} else if (shouldLoadData) {
			const authData = this.commonAppDataService.getDataByPath('bankroAuth');
			this.res = this.http.post(
				`${ window.location.origin }/authentication/account/login`,
				authData,
				requestOptions,
			).pipe(
				// get user profile and bootstrap only after authorization
				mergeMap(() => forkJoin([
						this.http.get(`${ window.location.origin }/api/UserProfiles/Get`, requestOptions),
						this.commonBootstrapDataService.init(shouldLoadData),
					]),
				));
		}

		return this.res = this.res
			.pipe(
				map((result) => {
					const user = isArray(result) ? get(result, '[0].Result') : result;

					this.setData(user);
					return user;
				}),
			);
	}

	wait (): Observable<any> {
		return this.res;
	}

	getUserAvatarUrl (id: string | null, mode: string): string {
		const size = commonConstants.USER_AVATAR_SIZE[mode] || commonConstants.USER_AVATAR_SIZE.standart;

		return isNull(id) ?
			'' :
			`${ commonConstants.downloadFilesAPIUrl }?id=${ id || this.getDataByPath('FileAvatarId') }&width=${ size }&height=${ size }`;
	}

	getUserForSuggest (): { Id: string; Name: string } {
		const user = this.getData();

		return {
			Id: user.Id,
			Name: user.DisplayName,
		};
	}

	isGuest (): boolean {
		return this.getDataByPath('Role') === 'Guest';
	}
}
